import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconBubbleWide"><Path d="M2.75 3C2.33579 3 2 3.33579 2 3.75V18.25C2 18.6642 2.33579 19 2.75 19H8.74274L11.5161 21.3248C11.7936 21.5574 12.1976 21.5585 12.4764 21.3275L15.2858 19H21.25C21.6642 19 22 18.6642 22 18.25V3.75C22 3.33579 21.6642 3 21.25 3H2.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWide;
